import React from 'react';
import { Link } from 'react-router-dom';
import '../AirlinePartner/AirlinePartner.css';

const AirlinePartner = () => {
  const images = [

    { id: 'air-newzealand', src: "/New-Zealand.jpg" },
  
    { id: 'eva-air', src: "/eva.jpg" },
    { id: 'qatar', src: "/a17.jpg" },
    { id: 'singapore', src: "/a18.jpg" },
    { id: 'united', src: "/a19.jpg" },
    { id: 'virginatlantic', src: "/a110.jpg" },
    { id: 'british', src: "/a11.jpg" },
    { id: 'malaysia-airlines', src: "/MALAYS1.jpg" },
    { id: 'garuda-indonesia', src: "/garuda.jpg" },
    { id: 'swiss', src: "/swiss.jpg" },
    { id: 'delta', src: "/delta.jpg" },
    { id: 'etihad', src: "/a15.jpg" },
   
    { id: 'cathaypacific', src: "/a12.jpg" },
   
    { id: 'klm', src: "/klm.jpg" },
    { id: 'emirates', src: "/a14.jpg" },
  
    { id: 'ana', src: "/ana.jpg" }
];

  return (
    <>
      <div className="post-a">
        <div className="overlay-a">
          <h1 className="text-a">Top Airline Partners</h1>
        </div>
      </div>

      <div className="text-center p-8">
  <h2 className="text-2xl font-bold mb-4 he">Find Your Perfect Airline</h2>
  <p className="het">
    Explore some of our most popular airline choices. We offer unbeatable prices, specializing in last-minute business and first-class travel—often at discounts of up to 50% off standard fares.
  </p>
  <p className="het">
    Click on any airline to get a glimpse of your business class experience, including top-tier service, gourmet dining, extra legroom, and exclusive lounge access. Enjoy a seamless journey from booking to landing with our trusted airline partners.
  </p>
</div>


      <div className="grid-container">
        {images.map(({ id, src }) => (
          <div key={id} className="grid-item">
            <Link to={`/airlines/${id}`}>
              <img src={src} alt={`Airline ${id}`} />
            </Link>
          </div>
        ))}
      </div>

      <section className="why-section">
  <h2>Why Book with Journey Experts Ltd?</h2>
  <hr />
  <div className="why-container">
    <div className="why-box">
      <p className="why-heading">Expertise</p>
      <p className="why-text">Expert team with 20+ years in the industry</p>
    </div>
    <div className="why-box">
      <p className="why-heading">Protection</p>
      <p className="why-text">Fully ATOL protected for your financial security</p>
    </div>
    <div className="why-box">
      <p className="why-heading">Trusted</p>
      <p className="why-text">UK-registered and trusted travel provider </p>
    </div>
    <div className="why-box">
      <p className="why-heading">Experience</p>
      <p className="why-text">Over 10 years of proven experience</p>
    </div>
    <div className="why-box">
      <p className="why-heading">Convenience</p>
      <p className="why-text"> Easy and secure online booking</p>
    </div>
  </div>
</section>

    </>
  );
};

export default AirlinePartner;
